import React from 'react';
import PropTypes from 'prop-types';

import './Ambassador.css';

export default class AmbassadorImage extends React.Component {
    static propTypes = {
        imageUrl: PropTypes.string.isRequired,
    };

    render() {
        return (
            <div
                className="ambassador-image"
                style={{ backgroundImage: `url(${this.props.imageUrl})` }}
            />
        );
    }
}
